import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { NEWSBOARD_STATUS } from '../../../constants/newsboard'
import { useUserData } from '../../../hooks'
import {
  EntityProfileHeader,
  EntityProfileHeaderEditTitleModal,
  EntityProfileHeaderTitleWithStatus,
} from '../../Entity'
import { ICON_HEIGHT_24 } from '../../Icon'
import { NEWSBOARD_TYPES_KEYS } from '../Newsboard.constants'
import { useNewsboardPostProfileContext } from '../Newsboard.hooks'
import { isNewsboardPostOwnerRestrictedFieldVisible } from '../Newsboard.utils'
import { NewsboardPostProfileHeaderContent } from '../NewsboardPostProfileHeaderContent'
import { NewsboardPostProfileHeaderEditTitleField } from '../NewsboardPostProfileHeaderEditTitleField'
import { NewsboardPostProfileHeaderFooter } from '../NewsboardPostProfileHeaderFooter'
import { useNewsboardPostProfileHeaderInfoItems } from '../NewsboardPostProfileHeaderInfoItems'

import { NEWSBOARD_POST_PROFILE_HEADER_EDIT_TITLE_BTN_QA_NAME } from './NewsboardPostProfileHeader.constants'
import {
  getNewsboardPostProfileHeaderEditTitleInitialValues,
  getNewsboardPostProfileHeaderEditTitleValidationSchema,
} from './NewsboardPostProfileHeader.utils'

import * as styles from './NewsboardPostProfileHeader.module.css'

import PostIcon from '../../../icons/post.svg'

function NewsboardPostProfileHeader() {
  const {
    handleCloseModal,
    handleUpdateEntity,
    isInitiated,
    postData,
    setModal,
  } = useNewsboardPostProfileContext()

  const { t } = useTranslation()

  const user = useUserData()

  const { infoItemsProps } = useNewsboardPostProfileHeaderInfoItems()

  const isStatusVisible = isNewsboardPostOwnerRestrictedFieldVisible(
    postData,
    user
  )

  const status = isStatusVisible ? postData?.status : null

  const typeTooltipKey = postData?.post_type?.title
    ? NEWSBOARD_TYPES_KEYS[postData.post_type.title]
    : null

  async function handleEditTitleSubmit({ value }) {
    await handleUpdateEntity(value)
    handleCloseModal()
  }

  function handleOpenEditTitleModal() {
    setModal(
      <EntityProfileHeaderEditTitleModal
        Fields={NewsboardPostProfileHeaderEditTitleField}
        formFieldsProps={{ ticker: postData?.isTvTicker }}
        initialValues={getNewsboardPostProfileHeaderEditTitleInitialValues(
          postData?.title
        )}
        validationSchema={getNewsboardPostProfileHeaderEditTitleValidationSchema(
          t,
          postData?.isTvTicker
        )}
        onClose={handleCloseModal}
        onSubmit={handleEditTitleSubmit}
      />
    )
  }

  return (
    <EntityProfileHeader
      Content={NewsboardPostProfileHeaderContent}
      Footer={NewsboardPostProfileHeaderFooter}
      Header={EntityProfileHeaderTitleWithStatus}
      className={styles.NewsboardPostProfileHeader}
      headerProps={{
        entityAvatarProps: {
          Icon: PostIcon,
          iconProps: { svgSize: ICON_HEIGHT_24 },
          tooltip: typeTooltipKey ? t(typeTooltipKey) : null,
        },
        sectionBackUrl: '/',
        statusProps: {
          id: status,
          statuses: NEWSBOARD_STATUS,
        },
        text: postData?.title,
        textPlaceholder: t('NewsboardPostProfile.HeaderNoTitleKey'),
        textProps: {
          editable: postData?.permissions?.can_edit,
          editButtonQaName:
            NEWSBOARD_POST_PROFILE_HEADER_EDIT_TITLE_BTN_QA_NAME,
          tooltipPlacement: FLOATING_ELEMENT_PLACEMENT.bottom,
        },
      }}
      infoItemsProps={infoItemsProps}
      isLoading={!isInitiated}
      onClickEditTitleButton={handleOpenEditTitleModal}
      onCloseModal={handleCloseModal}
      onSetModal={setModal}
    />
  )
}

export default NewsboardPostProfileHeader
